'use client'

import { useState } from 'react'
import { useSession } from 'next-auth/react'
import { toast } from '@/lib/toast'
import { submitVendorReportApi } from '@/lib/commerce/services/report-api'
import { validateVendorReport } from '@/utils/report'

export function useVendorReport(vendorId: string, onSuccess?: () => void) {
  const { data: session } = useSession()
  const customer = session?.user
  const isLoggedIn = !!customer?.id
  const fullName = isLoggedIn ? [customer?.firstName, customer?.lastName].filter(Boolean).join(' ') : ''

  const [reason, setReason] = useState('')
  const [message, setMessage] = useState('')
  const [guestName, setGuestName] = useState(fullName)
  const [guestEmail, setGuestEmail] = useState(customer?.email || '')
  const [guestPhone, setGuestPhone] = useState(customer?.phone || '')
  const [prevCustomerId, setPrevCustomerId] = useState(customer?.id || '')
  const [submitting, setSubmitting] = useState(false)

  if ((customer?.id || '') !== prevCustomerId) {
    setPrevCustomerId(customer?.id || '')
    setGuestName(fullName)
    setGuestEmail(customer?.email || '')
    setGuestPhone(customer?.phone || '')
  }

  const reset = () => {
    setReason('')
    setMessage('')
    setGuestName(fullName)
    setGuestEmail(customer?.email || '')
    setGuestPhone(customer?.phone || '')
  }

  const submit = async (): Promise<boolean> => {
    const err = validateVendorReport(reason, message, { name: guestName, phone: guestPhone, email: guestEmail })
    if (err) {
      toast.error(err)
      return false
    }
    setSubmitting(true)
    const result = await submitVendorReportApi({
      vendorId,
      auth: isLoggedIn,
      session: session || undefined,
      body: {
        reason,
        message: message.trim(),
        guestName: guestName.trim(),
        guestEmail: guestEmail.trim(),
        guestPhone: guestPhone.trim(),
      },
    })
    setSubmitting(false)
    if (!result || result.error || result.status !== 200) {
      toast.error(result?.error || 'Илгээхэд алдаа гарлаа')
      return false
    }
    toast.success('Мэдэгдэл амжилттай илгээгдлээ')
    reset()
    onSuccess?.()
    return true
  }

  return {
    reason, setReason,
    message, setMessage,
    guestName, setGuestName,
    guestEmail, setGuestEmail,
    guestPhone, setGuestPhone,
    submitting,
    submit, reset,
  }
}
